import { Fade } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import * as React from "react";
import { useSelector } from "react-redux";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import store from "../../../../redux/Store";
import classes from "./TableModal.module.css";
import DataTable from "../../DataTable/DataTable";

const TableModal = () => {
  const tableModal = useSelector((state) => state.common.tableModal);

  const handleClose = () => {
    store.dispatch(commonActions.closeTableModal());
  };

  // const onRowClick = (row) => {
  //   console.log(row);
  // };

  return (
    <div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={tableModal.isShowModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={tableModal.isShowModal}>
          <Box className={classes.modalBox}>
            <div className={classes.modalContent}>             
              <DataTable 
                onRowClick={() => {}}
                columns={tableModal.columns}
                rows={tableModal.rows}
                tableId={tableModal.tableId}
                isTableModal={true}
                toolBarTitle={tableModal.title}
                handleClose={handleClose}
                //selectedScope={selectedScope}
              />
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default TableModal;
